import { atom } from 'nanostores';
import type { AppUser } from '../types/auth';

export const $user = atom<AppUser | null>(null);
export const $isAuthenticated = atom<boolean>(false);
